import gql from "graphql-tag";

export default gql`
  query conversationMessages($conversationId: Int!) {
    conversationMessages(conversationId: $conversationId, first: 500) {
      nodes {
        id
        conversationId
        senderId
        content
        readAt
        createdAt
        userBySenderId {
          id
          firstname
          lastname
          profilePictureUrl
        }
      }
    }
  }
`;
